
import React, { useContext, useEffect, useState } from 'react';
import {
    Typography, Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
    CircularProgress
} from '@mui/material';
import axios from 'axios';
import apiUrl from "../../Config";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';

const DisplayLanguages = () => {
    const [languages, setLanguages] = useState([]);
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    const fetchLanguages = async () => {
        setLoading(true)
        try {
            const response = await axios.get(`${apiUrl}/languages/getalllanguage`);
            setLanguages(response.data.languages || []);
        } catch (error) {
            console.error("Error fetching languages:", error);
        } finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        fetchLanguages();
    }, []);

    const handleDelete = async (id) => {
        try {
            await axios.post(`${apiUrl}/languages/deletelanguage`, { id }, {
            });
            fetchLanguages();
        } catch (error) {
            console.error("Delete error:", error);
        }
    };

    const handleEdit = (language) => {
        navigate('/create-edit-languages', { state: { language } });
    };

    return (
        <Box mt={1} sx={{ padding: { sm: 2, xs: 2, md: 4, lg: 4 } }}>
            <Typography variant="h4" mb={2}>Languages</Typography>

            {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" height={200}>
                    <CircularProgress />
                </Box>
            ) : (
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Id</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Active</TableCell>
                                <TableCell align="right">Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {languages.map((language) => (
                                <TableRow key={language.id}>
                                    <TableCell>{language.id}</TableCell>
                                    <TableCell>{language.name}</TableCell>
                                    <TableCell>{language.isActive ? 'Yes' : 'No'}</TableCell>
                                    <TableCell align="right">
                                        <IconButton

                                            onClick={() => handleEdit(language)}
                                            sx={{ mr: 1 }}
                                        >
                                            <EditIcon size={18} />
                                        </IconButton>
                                        <IconButton
                                            color="error"
                                            onClick={() => handleDelete(language.id)}
                                        >
                                            <DeleteIcon size={18} />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </Box>
    );
};

export default DisplayLanguages;

